<div>
  <!-- user card -->
  <div class="card flex flex-col gap-6 min-w-0 px-5 py-6 md:px-10 md:py-12 relative">
    <!--<i class="absolute top-8 right-8 cursor-pointer">
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path d="M12.5 7.5C11.5335 7.5 10.75 6.7165 10.75 5.75C10.75 4.7835 11.5335 4 12.5 4C13.4665 4 14.25 4.7835 14.25 5.75C14.25 6.7165 13.4665 7.5 12.5 7.5ZM12.5 13.5C11.5335 13.5 10.75 12.7165 10.75 11.75C10.75 10.7835 11.5335 10 12.5 10C13.4665 10 14.25 10.7835 14.25 11.75C14.25 12.7165 13.4665 13.5 12.5 13.5ZM10.75 17.75C10.75 18.7165 11.5335 19.5 12.5 19.5C13.4665 19.5 14.25 18.7165 14.25 17.75C14.25 16.7835 13.4665 16 12.5 16C11.5335 16 10.75 16.7835 10.75 17.75Z" fill="#2C3035"/>
      </svg>
    </i>-->
    <div class="flex min-w-0 items-start gap-3">
      <div class="profile-information-value flex-1 text-[#2C3035] text-[1.375rem]/[160%] md:text-[1.9375rem] font-bold">
        {{ user()?.fullName }}
      </div>
      <button
        class="profile-menu-button"
        [attr.aria-label]="'profile.profileActions' | translate"
        nz-button
        nzType="text"
        nz-popconfirm
        appHideTooltipOnScroll
        [nzIcon]="null"
        nzPopconfirmPlacement="bottomRight"
        nzPopconfirmArrowPointAtCenter
        [nzPopconfirmOverlayClassName]="'action-menu-popconfirm-overlay'"
        [nzPopconfirmTitle]="profileMenu"
      >
        <i>
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path
              d="M12.25 7.5C11.2835 7.5 10.5 6.7165 10.5 5.75C10.5 4.7835 11.2835 4 12.25 4C13.2165 4 14 4.7835 14 5.75C14 6.7165 13.2165 7.5 12.25 7.5ZM12.25 13.5C11.2835 13.5 10.5 12.7165 10.5 11.75C10.5 10.7835 11.2835 10 12.25 10C13.2165 10 14 10.7835 14 11.75C14 12.7165 13.2165 13.5 12.25 13.5ZM10.5 17.75C10.5 18.7165 11.2835 19.5 12.25 19.5C13.2165 19.5 14 18.7165 14 17.75C14 16.7835 13.2165 16 12.25 16C11.2835 16 10.5 16.7835 10.5 17.75Z"
              fill="#505760"
            />
          </svg>
        </i>
      </button>
    </div>
    <div class="profile-information">
      @for (section of sections(); track section.id) {
        <div class="profile-information-row">
          <span class="text-[#2C3035] text-[0.9375rem]/[160%]">{{ section.label | translate }}</span>
          <span class="profile-information-value text-[#505760] text-[0.9375rem]/[160%]">{{ section.value }}</span>
        </div>
      }
    </div>
  </div>

  <!-- okeey cash account add -->
  <div class="w-full">
    <ng-container [ngTemplateOutlet]="okeeyCashAccountTemplate"></ng-container>
  </div>

  <!-- tax documentation -->
  @if (!user()?.isSpecial) {
    <div class="card tax-documentation-card px-5 py-4 h-[5.625rem] flex items-center justify-between mt-6">
      <div class="flex gap-2 items-center min-w-0">
        <span class="tax-documentation-card__title text-[#222528] text-[1.125rem]/[160%] font-medium">
          {{ 'profile.taxDocumentation' | translate }}
        </span>
        <i
          nz-tooltip
          appHideTooltipOnScroll
          [nzTooltipTitle]="'profile.uploadingTaxInformation' | translate"
          nzTooltipPlacement="right"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
            <path
              d="M10.5011 1.66602C15.1042 1.66602 18.8357 5.39708 18.8357 9.99958C18.8357 14.6021 15.1042 18.3331 10.5011 18.3331C5.89804 18.3331 2.1665 14.6021 2.1665 9.99958C2.1665 5.39708 5.89804 1.66602 10.5011 1.66602ZM10.5011 2.91586C6.5884 2.91586 3.4165 6.08735 3.4165 9.99958C3.4165 13.9118 6.5884 17.0833 10.5011 17.0833C14.4139 17.0833 17.5857 13.9118 17.5857 9.99958C17.5857 6.08735 14.4139 2.91586 10.5011 2.91586ZM10.4981 8.74891C10.8145 8.74874 11.0761 8.98363 11.1177 9.28867L11.1235 9.37341L11.1265 13.9575C11.1267 14.3026 10.8471 14.5827 10.5019 14.5828C10.1855 14.5831 9.9238 14.3481 9.88222 14.0432L9.87647 13.9583L9.87347 9.37425C9.8733 9.02912 10.1529 8.74916 10.4981 8.74891ZM10.5015 5.8345C10.9611 5.8345 11.3337 6.20705 11.3337 6.66661C11.3337 7.12617 10.9611 7.49872 10.5015 7.49872C10.0419 7.49872 9.6693 7.12617 9.6693 6.66661C9.6693 6.20705 10.0419 5.8345 10.5015 5.8345Z"
              fill="#2C3035"
            />
          </svg>
        </i>
      </div>
      @if (isTaxDocumentationLoading()) {
        <span class="text-[#737980] text-[0.9375rem]">{{ 'common.loading' | translate }}</span>
      } @else if (hasTaxDocumentation()) {
        <div class="tax-documentation-card__actions">
          <app-tag type="success">{{ 'profile.completed' | translate }}</app-tag>
          <button
            class="tax-documentation-card__menu-button"
            nz-button
            nzType="text"
            nz-popconfirm
            appHideTooltipOnScroll
            [nzIcon]="null"
            nzPopconfirmPlacement="bottomRight"
            nzPopconfirmArrowPointAtCenter
            [nzPopconfirmOverlayClassName]="'action-menu-popconfirm-overlay'"
            [nzPopconfirmTitle]="taxDocumentationMenu"
            [attr.aria-label]="'profile.seeDetails' | translate"
          >
            <i>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path
                  d="M12.25 7.5C11.2835 7.5 10.5 6.7165 10.5 5.75C10.5 4.7835 11.2835 4 12.25 4C13.2165 4 14 4.7835 14 5.75C14 6.7165 13.2165 7.5 12.25 7.5ZM12.25 13.5C11.2835 13.5 10.5 12.7165 10.5 11.75C10.5 10.7835 11.2835 10 12.25 10C13.2165 10 14 10.7835 14 11.75C14 12.7165 13.2165 13.5 12.25 13.5ZM10.5 17.75C10.5 18.7165 11.2835 19.5 12.25 19.5C13.2165 19.5 14 18.7165 14 17.75C14 16.7835 13.2165 16 12.25 16C11.2835 16 10.5 16.7835 10.5 17.75Z"
                  fill="#2C3035"
                />
              </svg>
            </i>
          </button>
        </div>
      } @else {
        <div
          class="h-6 px-2 flex gap-2 items-center border-dashed border-[#737980] border rounded-md cursor-pointer"
          (click)="onAddTaxDocumentation()"
        >
          <span class="text-[#737980] text-[0.9375rem]">{{ 'profile.add' | translate }}</span>
          <i>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
              <path
                d="M7.83173 2.5C8.08487 2.5 8.29413 2.68801 8.32727 2.93205L8.33187 2.9999L8.33267 7.83333H13.1681C13.4442 7.83333 13.6681 8.0572 13.6681 8.33333C13.6681 8.58647 13.4799 8.79567 13.2359 8.8288L13.1681 8.83333H8.33267L8.334 13.6661C8.33407 13.9422 8.11027 14.1662 7.83413 14.1662C7.581 14.1662 7.37173 13.9782 7.3386 13.7341L7.334 13.6663L7.33267 8.83333H2.5C2.22385 8.83333 2 8.60947 2 8.33333C2 8.0802 2.1881 7.871 2.43215 7.83787L2.5 7.83333H7.33267L7.33187 3.0001C7.3318 2.72396 7.5556 2.5 7.83173 2.5Z"
                fill="#737980"
              />
            </svg>
          </i>
        </div>
      }
    </div>
  }

  <!-- payment account -->
  @if (user()?.isSpecial) {
    <div class="card px-5 py-4 h-[5.625rem] flex items-center justify-between mt-6">
      <div class="flex gap-2 items-center">
        <span class="text-[#222528]/[160%] text-[1.125rem] font-medium">
          {{ 'profile.paymentAccount' | translate }}
        </span>
        <i
          nz-tooltip
          appHideTooltipOnScroll
          [nzTooltipTitle]="'profile.paymentAccountDesc' | translate"
          nzTooltipPlacement="right"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
            <path
              d="M10.5011 1.66602C15.1042 1.66602 18.8357 5.39708 18.8357 9.99958C18.8357 14.6021 15.1042 18.3331 10.5011 18.3331C5.89804 18.3331 2.1665 14.6021 2.1665 9.99958C2.1665 5.39708 5.89804 1.66602 10.5011 1.66602ZM10.5011 2.91586C6.5884 2.91586 3.4165 6.08735 3.4165 9.99958C3.4165 13.9118 6.5884 17.0833 10.5011 17.0833C14.4139 17.0833 17.5857 13.9118 17.5857 9.99958C17.5857 6.08735 14.4139 2.91586 10.5011 2.91586ZM10.4981 8.74891C10.8145 8.74874 11.0761 8.98363 11.1177 9.28867L11.1235 9.37341L11.1265 13.9575C11.1267 14.3026 10.8471 14.5827 10.5019 14.5828C10.1855 14.5831 9.9238 14.3481 9.88222 14.0432L9.87647 13.9583L9.87347 9.37425C9.8733 9.02912 10.1529 8.74916 10.4981 8.74891ZM10.5015 5.8345C10.9611 5.8345 11.3337 6.20705 11.3337 6.66661C11.3337 7.12617 10.9611 7.49872 10.5015 7.49872C10.0419 7.49872 9.6693 7.12617 9.6693 6.66661C9.6693 6.20705 10.0419 5.8345 10.5015 5.8345Z"
              fill="#2C3035"
            />
          </svg>
        </i>
      </div>
      <div class="flex gap-2">
        @if (paymentAccountStatusIsEmpty()) {
          <button
            class="h-6 px-2 flex gap-2 items-center border-dashed border-[#737980] border rounded-md cursor-pointer"
            (click)="onAddPaymentAccountClick()"
          >
            <span class="text-[#737980] text-[0.9375rem]">{{ 'profile.add' | translate }}</span>
            <i nz-icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                <path
                  d="M7.83173 2.5C8.08487 2.5 8.29413 2.68801 8.32727 2.93205L8.33187 2.9999L8.33267 7.83333H13.1681C13.4442 7.83333 13.6681 8.0572 13.6681 8.33333C13.6681 8.58647 13.4799 8.79567 13.2359 8.8288L13.1681 8.83333H8.33267L8.334 13.6661C8.33407 13.9422 8.11027 14.1662 7.83413 14.1662C7.581 14.1662 7.37173 13.9782 7.3386 13.7341L7.334 13.6663L7.33267 8.83333H2.5C2.22385 8.83333 2 8.60947 2 8.33333C2 8.0802 2.1881 7.871 2.43215 7.83787L2.5 7.83333H7.33267L7.33187 3.0001C7.3318 2.72396 7.5556 2.5 7.83173 2.5Z"
                  fill="#737980"
                />
              </svg>
            </i>
          </button>
        } @else {
          @if (defaultPaymentAccount()) {
            <span class="text-base md:text-lg approved">{{
              defaultPaymentAccount().bank_information?.account_number?.value ??
                defaultPaymentAccount().bank_information?.clabe_number?.value | mask
            }}</span>
          } @else if (paymentAccountStatusIsDeclined()) {
            <app-tag type="error">
              {{ 'profile.declined' | translate }}
            </app-tag>
          } @else if (paymentAccountStatusIsReviewing()) {
            <app-tag type="warning">
              {{ 'profile.reviewing' | translate }}
            </app-tag>
          }
          <button nz-button nzType="text" (click)="onEditPaymentAccountClick()">
            <i nz-icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path
                  d="M20.9519 2.5481C19.5543 1.15058 17.2885 1.15064 15.8911 2.54825L3.94103 14.4997C3.5347 14.9061 3.2491 15.4172 3.116 15.9762L2.02041 20.5777C1.96009 20.8311 2.03552 21.0976 2.21968 21.2817C2.40385 21.4659 2.67037 21.5413 2.92373 21.481L7.52498 20.3855C8.08418 20.2523 8.59546 19.9666 9.00191 19.5601L20.952 7.60861C22.3493 6.21112 22.3493 3.9455 20.9519 2.5481ZM16.9518 3.60884C17.7634 2.79709 19.0795 2.79705 19.8912 3.60876C20.7028 4.4204 20.7029 5.73632 19.8913 6.54801L19 7.43946L16.0606 4.50012L16.9518 3.60884ZM15 5.56084L17.9394 8.50018L7.94119 18.4995C7.73104 18.7097 7.46668 18.8574 7.17755 18.9263L3.76191 19.7395L4.57521 16.3237C4.64402 16.0346 4.79168 15.7704 5.00175 15.5603L15 5.56084Z"
                  fill="#505760"
                />
              </svg>
            </i>
          </button>
        }
      </div>
    </div>
  }

  <!--<div class="w-full text-center text-black text-[1.375rem] font-bold my-6">
    {{ 'profile.preferences' | translate }}
  </div>-->

  <div class="w-full h-[0.0625rem] bg-[#EEEEEF] my-4 md:my-8"></div>

  <!-- notifications -->
  <div class="card notifications-card px-5 py-4 min-h-[5.625rem] mt-6">
    <div class="flex gap-2 items-center">
      <span class="text-[#222528]/[160%] text-[1.125rem] font-medium">{{ 'profile.notifications' | translate }}</span>
      <i
        nz-tooltip
        appHideTooltipOnScroll
        [nzTooltipTitle]="'profile.thisIsThePreferredLanguage' | translate"
        nzTooltipPlacement="right"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path
            d="M10.5011 1.66602C15.1042 1.66602 18.8357 5.39708 18.8357 9.99958C18.8357 14.6021 15.1042 18.3331 10.5011 18.3331C5.89804 18.3331 2.1665 14.6021 2.1665 9.99958C2.1665 5.39708 5.89804 1.66602 10.5011 1.66602ZM10.5011 2.91586C6.5884 2.91586 3.4165 6.08735 3.4165 9.99958C3.4165 13.9118 6.5884 17.0833 10.5011 17.0833C14.4139 17.0833 17.5857 13.9118 17.5857 9.99958C17.5857 6.08735 14.4139 2.91586 10.5011 2.91586ZM10.4981 8.74891C10.8145 8.74874 11.0761 8.98363 11.1177 9.28867L11.1235 9.37341L11.1265 13.9575C11.1267 14.3026 10.8471 14.5827 10.5019 14.5828C10.1855 14.5831 9.9238 14.3481 9.88222 14.0432L9.87647 13.9583L9.87347 9.37425C9.8733 9.02912 10.1529 8.74916 10.4981 8.74891ZM10.5015 5.8345C10.9611 5.8345 11.3337 6.20705 11.3337 6.66661C11.3337 7.12617 10.9611 7.49872 10.5015 7.49872C10.0419 7.49872 9.6693 7.12617 9.6693 6.66661C9.6693 6.20705 10.0419 5.8345 10.5015 5.8345Z"
            fill="#2C3035"
          />
        </svg>
      </i>
    </div>
    <nz-radio-group
      class="notification-language-options"
      [attr.aria-label]="'profile.notifications' | translate"
      [(ngModel)]="language"
      (ngModelChange)="onLanguageChange($event)"
    >
      <label class="notification-language-option" nz-radio nzValue="es">
        {{ 'profile.spanish' | translate }}
      </label>
      <label class="notification-language-option" nz-radio nzValue="en">
        {{ 'profile.english' | translate }}
      </label>
    </nz-radio-group>
  </div>

  @if (user()?.isSpecial) {
    <div class="w-full h-[0.0625rem] bg-[#EEEEEF] my-4 md:my-8"></div>
  }

  @if (user()?.isSpecial) {
    <!-- contract -->
    <div class="card px-5 py-4 min-h-[5.625rem] flex items-center justify-between gap-3 mt-6">
      <div class="flex min-w-0 flex-1 flex-col gap-1">
        <span class="text-[#222528]/[160%] text-[1.125rem] font-medium">
          {{ 'profile.contract' | translate }}
        </span>
        <span class="text-[#505760] text-[0.9375rem]/[160%]">
          {{ 'profile.contactAdministrationForContract' | translate }}
        </span>
      </div>
      <div class="shrink-0">
        <button
          nz-button
          nzType="text"
          [attr.aria-label]="'profile.contactAdministrationForContract' | translate"
          (click)="onContractContactClick()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <rect x="3" y="5" width="18" height="14" rx="2" stroke="#505760" stroke-width="1.5" />
            <path
              d="M4 7L12 13L20 7"
              stroke="#505760"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  }

  <!-- terms conditions -->
  <a
    class="card terms-and-conditions-card px-5 py-4 h-[5.625rem] flex items-center justify-between mt-6"
    routerLink="/terms-and-conditions"
    target="_blank"
    rel="noopener noreferrer"
  >
    <div class="flex gap-2 items-center">
      <span class="text-[#222528]/[160%] text-[1.125rem] font-medium">
        {{ 'profile.termsAndConditions' | translate }}
      </span>
    </div>
    <span class="inline-flex items-center justify-center h-8 px-[15px] shrink-0" aria-hidden="true">
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M6.74992 5C5.78344 5 4.99996 5.7835 4.99996 6.75V18.25C4.99996 19.2165 5.78344 20 6.74992 20H18.2496C19.2161 20 19.9996 19.2165 19.9996 18.25V14.25C19.9996 13.8358 20.3354 13.5 20.7496 13.5C21.1638 13.5 21.4995 13.8358 21.4995 14.25V18.25C21.4995 20.0449 20.0445 21.5 18.2496 21.5H6.74992C4.95504 21.5 3.5 20.0449 3.5 18.25V6.75C3.5 4.95507 4.95504 3.5 6.74992 3.5H10.7498C11.164 3.5 11.4998 3.83579 11.4998 4.25C11.4998 4.66421 11.164 5 10.7498 5H6.74992ZM13.4997 4.25C13.4997 3.83579 13.8355 3.5 14.2497 3.5H20.75C21.1642 3.5 21.5 3.83579 21.5 4.25V10.75C21.5 11.1642 21.1642 11.5 20.75 11.5C20.3358 11.5 20 11.1642 20 10.75V6.06074L14.78 11.2804C14.4871 11.5732 14.0123 11.5732 13.7194 11.2803C13.4265 10.9874 13.4265 10.5125 13.7194 10.2196L18.9395 5H14.2497C13.8355 5 13.4997 4.66421 13.4997 4.25Z"
            fill="#505760"
          />
        </svg>
      </i>
    </span>
  </a>
</div>

<ng-template #okeeyCashAccountTemplate>
  <div class="card px-5 py-4 h-[5.625rem] flex items-center justify-between mt-6">
    <div class="flex gap-2 items-center">
      <span class="text-[#222528]/[160%] text-[1.125rem] font-medium">{{
        'profile.okeeyCashAccount' | translate
      }}</span>
      <i
        nz-tooltip
        appHideTooltipOnScroll
        [nzTooltipTitle]="'profile.thisAccountWillBeUsed' | translate"
        nzTooltipPlacement="right"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path
            d="M10.5011 1.66602C15.1042 1.66602 18.8357 5.39708 18.8357 9.99958C18.8357 14.6021 15.1042 18.3331 10.5011 18.3331C5.89804 18.3331 2.1665 14.6021 2.1665 9.99958C2.1665 5.39708 5.89804 1.66602 10.5011 1.66602ZM10.5011 2.91586C6.5884 2.91586 3.4165 6.08735 3.4165 9.99958C3.4165 13.9118 6.5884 17.0833 10.5011 17.0833C14.4139 17.0833 17.5857 13.9118 17.5857 9.99958C17.5857 6.08735 14.4139 2.91586 10.5011 2.91586ZM10.4981 8.74891C10.8145 8.74874 11.0761 8.98363 11.1177 9.28867L11.1235 9.37341L11.1265 13.9575C11.1267 14.3026 10.8471 14.5827 10.5019 14.5828C10.1855 14.5831 9.9238 14.3481 9.88222 14.0432L9.87647 13.9583L9.87347 9.37425C9.8733 9.02912 10.1529 8.74916 10.4981 8.74891ZM10.5015 5.8345C10.9611 5.8345 11.3337 6.20705 11.3337 6.66661C11.3337 7.12617 10.9611 7.49872 10.5015 7.49872C10.0419 7.49872 9.6693 7.12617 9.6693 6.66661C9.6693 6.20705 10.0419 5.8345 10.5015 5.8345Z"
            fill="#2C3035"
          />
        </svg>
      </i>
    </div>
    @switch (okeeyCashAccountStatus()) {
      @case (OkeeyCashAccountNumberStatuses.REVIEW) {
        <app-tag type="warning">{{ 'profile.pending' | translate }}</app-tag>
      }
      @case (OkeeyCashAccountNumberStatuses.REVIEWING) {
        <app-tag type="warning">{{ 'profile.pending' | translate }}</app-tag>
      }
      @case (OkeeyCashAccountNumberStatuses.DECLINED) {
        <app-tag type="error">{{ 'profile.declined' | translate }}</app-tag>
      }
      @case (OkeeyCashAccountNumberStatuses.APPROVED) {
        <div class="flex flex-row gap-2 items-center shrink-0">
          <app-tag type="success">{{ 'profile.verified' | translate }}</app-tag>
          <button
            nz-button
            nzType="text"
            [attr.aria-label]="'profile.removeAccount' | translate"
            (click)="onRemoveOkeeyCashAccount()"
          >
            <i>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path
                  d="M8 3.5H12C12 2.39543 11.1046 1.5 10 1.5C8.8954 1.5 8 2.39543 8 3.5ZM6.5 3.5C6.5 1.567 8.067 0 10 0C11.933 0 13.5 1.567 13.5 3.5H19.25C19.6642 3.5 20 3.83579 20 4.25C20 4.66421 19.6642 5 19.25 5H17.9309L16.7589 17.1112C16.5729 19.0334 14.9575 20.5 13.0263 20.5H6.97369C5.04254 20.5 3.42715 19.0334 3.24113 17.1112L2.06908 5H0.75C0.33579 5 0 4.66421 0 4.25C0 3.83579 0.33579 3.5 0.75 3.5H6.5ZM8.5 8.25C8.5 7.83579 8.1642 7.5 7.75 7.5C7.33579 7.5 7 7.83579 7 8.25V15.75C7 16.1642 7.33579 16.5 7.75 16.5C8.1642 16.5 8.5 16.1642 8.5 15.75V8.25ZM12.25 7.5C12.6642 7.5 13 7.83579 13 8.25V15.75C13 16.1642 12.6642 16.5 12.25 16.5C11.8358 16.5 11.5 16.1642 11.5 15.75V8.25C11.5 7.83579 11.8358 7.5 12.25 7.5ZM4.73416 16.9667C4.84577 18.12 5.815 19 6.97369 19H13.0263C14.185 19 15.1542 18.12 15.2658 16.9667L16.4239 5H3.57608L4.73416 16.9667Z"
                  fill="#505760"
                />
              </svg>
            </i>
          </button>
        </div>
      }
      @default {
        <app-tag type="info">{{
          (okeeyCashAccountStatus() ? 'profile.accountStatusUnavailable' : 'profile.accountNotLinked') | translate
        }}</app-tag>
      }
    }
  </div>
</ng-template>

<ng-template #taxDocumentationMenu>
  <div class="action-menu-popconfirm">
    <button nz-button nzType="text" class="p-0" (click)="onTaxDocumentationDetailsClick()">
      <div class="flex flex-row gap-2">
        <i nz-icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path
              d="M11.9984 9.50462C14.2075 9.50462 15.9984 11.2955 15.9984 13.5046C15.9984 15.7138 14.2075 17.5046 11.9984 17.5046C9.78926 17.5046 7.9984 15.7138 7.9984 13.5046C7.9984 11.2955 9.78926 9.50462 11.9984 9.50462ZM11.9984 11.0046C10.6177 11.0046 9.4984 12.1239 9.4984 13.5046C9.4984 14.8853 10.6177 16.0046 11.9984 16.0046C13.3791 16.0046 14.4984 14.8853 14.4984 13.5046C14.4984 12.1239 13.3791 11.0046 11.9984 11.0046ZM11.9984 6C16.6119 6 20.5945 9.15001 21.6995 13.5644C21.8001 13.9662 21.5559 14.3735 21.1541 14.4741C20.7522 14.5746 20.345 14.3305 20.2444 13.9286C19.3055 10.178 15.9197 7.5 11.9984 7.5C8.07534 7.5 4.6885 10.1803 3.75126 13.9332C3.6509 14.335 3.24376 14.5794 2.84189 14.4791C2.44002 14.3787 2.1956 13.9716 2.29596 13.5697C3.39905 9.15272 7.38289 6 11.9984 6Z"
              fill="#2C3035"
            />
          </svg>
        </i>
        <span class="font-medium text-base">{{ 'profile.seeDetails' | translate }}</span>
      </div>
    </button>
    <button
      nz-button
      nzType="text"
      class="p-0 action-menu-popconfirm__danger"
      [disabled]="isTaxDocumentationLoading()"
      (click)="onRemoveTaxDocumentationClick()"
    >
      <div class="flex flex-row gap-2">
        <i nz-icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path
              d="M10 5.5H14C14 4.39543 13.1046 3.5 12 3.5C10.8954 3.5 10 4.39543 10 5.5ZM8.5 5.5C8.5 3.567 10.067 2 12 2C13.933 2 15.5 3.567 15.5 5.5H21.25C21.6642 5.5 22 5.83579 22 6.25C22 6.66421 21.6642 7 21.25 7H19.9309L18.7589 19.1112C18.5729 21.0334 16.9575 22.5 15.0263 22.5H8.97369C7.04254 22.5 5.42715 21.0334 5.24113 19.1112L4.06908 7H2.75C2.33579 7 2 6.66421 2 6.25C2 5.83579 2.33579 5.5 2.75 5.5H8.5ZM10.5 10.25C10.5 9.83579 10.1642 9.5 9.75 9.5C9.33579 9.5 9 9.83579 9 10.25V17.75C9 18.1642 9.33579 18.5 9.75 18.5C10.1642 18.5 10.5 18.1642 10.5 17.75V10.25ZM14.25 9.5C14.6642 9.5 15 9.83579 15 10.25V17.75C15 18.1642 14.6642 18.5 14.25 18.5C13.8358 18.5 13.5 18.1642 13.5 17.75V10.25C13.5 9.83579 13.8358 9.5 14.25 9.5ZM6.73416 18.9667C6.84577 20.12 7.815 21 8.97369 21H15.0263C16.185 21 17.1542 20.12 17.2658 18.9667L18.4239 7H5.57608L6.73416 18.9667Z"
              fill="#CB2222"
            />
          </svg>
        </i>
        <span class="font-medium text-base">{{ 'profile.remove' | translate }}</span>
      </div>
    </button>
  </div>
</ng-template>

<ng-template #profileMenu>
  <div class="action-menu-popconfirm">
    <button nz-button nzType="text" class="p-0" (click)="onChangePersonalInfoClick()">
      <div class="flex flex-row gap-2">
        <i>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M20.9519 2.0481C19.5543 0.650579 17.2885 0.650639 15.8911 2.04825L3.94103 13.9997C3.5347 14.4061 3.2491 14.9172 3.116 15.4762L2.02041 20.0777C1.96009 20.3311 2.03552 20.5976 2.21968 20.7817C2.40385 20.9659 2.67037 21.0413 2.92373 20.981L7.52498 19.8855C8.08418 19.7523 8.59546 19.4666 9.00191 19.0601L20.952 7.10861C22.3493 5.71112 22.3493 3.4455 20.9519 2.0481ZM16.9518 3.10884C17.7634 2.29709 19.0795 2.29705 19.8912 3.10876C20.7028 3.9204 20.7029 5.23632 19.8913 6.04801L19 6.93946L16.0606 4.00012L16.9518 3.10884ZM15 5.06084L17.9394 8.00018L7.94119 17.9995C7.73104 18.2097 7.46668 18.3574 7.17755 18.4263L3.76191 19.2395L4.57521 15.8237C4.64402 15.5346 4.79168 15.2704 5.00175 15.0603L15 5.06084Z"
              fill="#2C3035"
            />
          </svg>
        </i>
        <span class="font-medium text-base">{{ 'profile.editProfile' | translate }}</span>
      </div>
    </button>
    <button nz-button nzType="text" class="p-0 action-menu-popconfirm__danger" (click)="onDeleteAccountClick()">
      <div class="flex flex-row gap-2">
        <i>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M10 5H14C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5ZM8.5 5C8.5 3.067 10.067 1.5 12 1.5C13.933 1.5 15.5 3.067 15.5 5H21.25C21.6642 5 22 5.33579 22 5.75C22 6.16421 21.6642 6.5 21.25 6.5H19.9309L18.7589 18.6112C18.5729 20.5334 16.9575 22 15.0263 22H8.97369C7.04254 22 5.42715 20.5334 5.24113 18.6112L4.06908 6.5H2.75C2.33579 6.5 2 6.16421 2 5.75C2 5.33579 2.33579 5 2.75 5H8.5ZM10.5 9.75C10.5 9.33579 10.1642 9 9.75 9C9.33579 9 9 9.33579 9 9.75V17.25C9 17.6642 9.33579 18 9.75 18C10.1642 18 10.5 17.6642 10.5 17.25V9.75ZM14.25 9C14.6642 9 15 9.33579 15 9.75V17.25C15 17.6642 14.6642 18 14.25 18C13.8358 18 13.5 17.6642 13.5 17.25V9.75C13.5 9.33579 13.8358 9 14.25 9ZM6.73416 18.4667C6.84577 19.62 7.815 20.5 8.97369 20.5H15.0263C16.185 20.5 17.1542 19.62 17.2658 18.4667L18.4239 6.5H5.57608L6.73416 18.4667Z"
              fill="#CB2222"
            />
          </svg>
        </i>
        <span class="font-medium text-base">{{ 'profile.deleteAccount' | translate }}</span>
      </div>
    </button>
  </div>
</ng-template>
